/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * Replaces the Dato-specific portion of a Dato asset's URL
 * by the subdirectory `/assets/`. This allows the asset to
 * be served under our domain via a rewrite in Next.js
 * middleware.
 *
 * @param {String} url A Dato asset URL
 * @returns A Dato asset URL with the Dato-specific portion replaced by '/assets/'
 */
export default function datoURLToAssetSubdir(url) {
	return url.replace('https://www.datocms-assets.com/2885/', '/assets/')
}
